import React, {useEffect, useState} from 'react';
import {CardProductCodeName} from "../../constants/Card";
import { getVersionUrl } from 'common/cacheOverwrite';

type Props = {
  cardProductCode: string;
  designDivisionCode?: string;
  cardProductCodeName?: string;
}

const CardInfo: React.FC<Props> = ({cardProductCode, designDivisionCode = 'B', cardProductCodeName}) => {

  const [cardName, setCardName] = useState<string>(CardProductCodeName[Number(cardProductCode)]);

  useEffect(() => {
    setCardName(CardProductCodeName[Number(cardProductCode)]);
  }, [cardProductCode]);

  return (
    <div className="cardInfo">
      <img src={getVersionUrl(localStorage.getItem(`${cardProductCode}_${designDivisionCode}`) as string)} alt={cardProductCodeName || cardName}/>
      <span>{cardProductCodeName || cardName}</span>
    </div>
  );
};

export default CardInfo;
